import CategoryCalloutDisplay from './component'

export default CategoryCalloutDisplay
